/* Trio Sporting — annual/biennial (1y/2y) tier toggle.
   Ported verbatim behaviour from membership.html inline script.
   Vanilla, delegated, no dependencies. Works for any number of
   [data-period-btn] controls + [data-period] tier cards on the page. */
(function () {
  function setPeriod(scope, val) {
    scope.querySelectorAll('[data-period-btn]').forEach(function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-period-btn') === val);
    });
    scope.querySelectorAll('[data-period]').forEach(function (c) {
      c.style.display = (c.getAttribute('data-period') === val) ? '' : 'none';
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-period-btn]');
    if (!b) return;
    var scope = b.closest('[data-period-scope]') || document;
    setPeriod(scope, b.getAttribute('data-period-btn'));
  });
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-period-scope]').forEach(function (scope) {
      var first = scope.querySelector('[data-period-btn]');
      if (first) setPeriod(scope, first.getAttribute('data-period-btn'));
    });
  });
})();
